import { theme } from "config/theme";
import styled from "styled-components/macro";
import { CardContainerSmallStyle } from "assets/styles/global";

export const UserQuestionsContainer = styled.div`
    ${CardContainerSmallStyle};
    margin-bottom: ${theme.spacing.medium};
    padding: ${theme.spacing.small};
`;
